<app-header class="fixed-header" [title]="LITERALS.ADMIN.TITTLE"></app-header>
<p-sidebar class="fixed-sidebar" styleClass="menu-filter" [modal]="false" (onShow)="onResize()" position="left">
  <!-- <app-user-filter
    (closeHimself)="filterDisplay = false"
    [table]="adminUsersTable"
    [today]="today"
    [isFiltered]="isFiltered"
    [filteredUsers]="filteredAdminUsers"
  ></app-user-filter> -->
</p-sidebar>
<div class="movanoMiddleBar fixed-middle-bar">
  <div class="movanoMiddleBar_First">
    <app-calendar
      #list_calendar
      [slctdDateOpt]="selectedDate"
      (initGetInfo)="emitGetInfo($event)"
      [timeZones]="timeZones"
      [ngStyle]="{ 'pointer-events': valueSearch ? 'none' : 'auto', opacity: valueSearch ? '0.5' : '1' }"
    ></app-calendar>
    <!-- <svg
      class="movanoHeader_Tittle_btn"
      style="margin-left: 20px"
      width="max(1.11vw, 16px)"
      height="max(1.11vw, 16px)"
      *ngIf="!searchDisplay"
      (click)="searchDisplay = true"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9167 9.66667H10.2583L10.025 9.44167C10.8417 8.49167 11.3333 7.25833 11.3333 5.91667C11.3333 2.925 8.90833 0.5 5.91667 0.5C2.925 0.5 0.5 2.925 0.5 5.91667C0.5 8.90833 2.925 11.3333 5.91667 11.3333C7.25833 11.3333 8.49167 10.8417 9.44167 10.025L9.66667 10.2583V10.9167L13.8333 15.075L15.075 13.8333L10.9167 9.66667V9.66667ZM5.91667 9.66667C3.84167 9.66667 2.16667 7.99167 2.16667 5.91667C2.16667 3.84167 3.84167 2.16667 5.91667 2.16667C7.99167 2.16667 9.66667 3.84167 9.66667 5.91667C9.66667 7.99167 7.99167 9.66667 5.91667 9.66667Z"
        fill="var(--main-blue-dark)"
      />
    </svg> -->
    <!-- <div
      style="margin-right: 20px; margin-left: 20px"
      *ngIf="searchDisplay"
      class="movanoHeader_Tittle_Search scale-up-hor-left"
    >
      <svg
        (click)="search($event, 'user_id', userTable)"
        width="max(1.11vw, 16px)"
        height="max(1.11vw, 16px)"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.9167 9.66667H10.2583L10.025 9.44167C10.8417 8.49167 11.3333 7.25833 11.3333 5.91667C11.3333 2.925 8.90833 0.5 5.91667 0.5C2.925 0.5 0.5 2.925 0.5 5.91667C0.5 8.90833 2.925 11.3333 5.91667 11.3333C7.25833 11.3333 8.49167 10.8417 9.44167 10.025L9.66667 10.2583V10.9167L13.8333 15.075L15.075 13.8333L10.9167 9.66667V9.66667ZM5.91667 9.66667C3.84167 9.66667 2.16667 7.99167 2.16667 5.91667C2.16667 3.84167 3.84167 2.16667 5.91667 2.16667C7.99167 2.16667 9.66667 3.84167 9.66667 5.91667C9.66667 7.99167 7.99167 9.66667 5.91667 9.66667Z"
          fill="var(--main-blue-dark)"
        />
      </svg>
      <span class="p-input-icon-left">
        <input
          class="movanoInputSearch"
          type="text"
          placeholder="Search user"
          #searchInput
          pInputText
          (input)="search($event, 'user_id', userTable)"
        />
      </span>
      <svg
        width="max(0.833vw, 16px)"
        height="max(0.833vw, 16px)"
        (click)="clearSearch(searchInput, userTable); searchDisplay = false; this.isFiltered = false"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z"
          fill="#C4D9EE"
        />
      </svg>
    </div> -->
    <!-- <svg
      style="margin-left: 20px"
      (click)="filterDisplay = true"
      class="movanoHeader_Tittle_btn"
      width="max(0.9vw, 16px)"
      height="max(0.9vw, 16px)"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.364543 1.48084C0.443709 1.58375 4.90871 7.28375 4.90871 7.28375V12.0417C4.90871 12.4771 5.26496 12.8333 5.70829 12.8333H7.29954C7.73496 12.8333 8.09913 12.4771 8.09913 12.0417V7.27584C8.09913 7.27584 12.4454 1.71834 12.6512 1.465C12.857 1.21167 12.8333 0.958338 12.8333 0.958338C12.8333 0.522922 12.477 0.166672 12.0337 0.166672H0.966209C0.483293 0.166672 0.166626 0.546672 0.166626 0.958338C0.166626 1.11667 0.214126 1.30667 0.364543 1.48084Z"
        fill="var(--main-blue-dark)"
      />
    </svg> -->
  </div>

  <div class="movanoMiddleBar_Last">
    <span class="movanoMiddleBar_Last_Amount">{{ adminUsersTimeframeTotal }} Users</span>

    <svg
      style="margin-right: 30px; cursor: pointer"
      (click)="exportCSV()"
      width="max(1.11vw, 17px)"
      height="max(1.11vw, 19px)"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.186 1.1897e-05H4.60464L3.00801 0L3 16C3 16 3.71406 16 4.59662 16H13.3953C14.2779 16 15 16 15 16V4.75109L10.186 1.1897e-05ZM13.3953 14.393H4.60464V1.53712H9.38372V5.55458H13.3953V14.393Z"
        fill="#054280"
      />
      <path d="M0 10H17V19H0V10Z" fill="#054280" />
      <path d="M12.8696 17L11.1546 12.1H12.1276L13.3316 15.775L14.5426 12.1H15.5156L13.7936 17H12.8696Z" fill="white" />
      <path
        d="M8.99207 17.105C8.57207 17.105 8.18474 17.014 7.83007 16.832C7.48007 16.6453 7.2024 16.3303 6.99707 15.887L7.76007 15.467C7.8954 15.7097 8.05874 15.8987 8.25007 16.034C8.4414 16.1693 8.7004 16.237 9.02707 16.237C9.34907 16.237 9.56374 16.1833 9.67107 16.076C9.7784 15.964 9.83207 15.817 9.83207 15.635C9.83207 15.5183 9.80407 15.418 9.74807 15.334C9.69674 15.25 9.58007 15.1707 9.39807 15.096C9.22074 15.0167 8.9454 14.9327 8.57207 14.844C8.1194 14.7367 7.78574 14.564 7.57107 14.326C7.3564 14.088 7.24907 13.7917 7.24907 13.437C7.24907 13.143 7.31907 12.8863 7.45907 12.667C7.59907 12.4477 7.79507 12.2773 8.04707 12.156C8.30374 12.03 8.60474 11.967 8.95007 11.967C9.2674 11.967 9.5474 12.016 9.79007 12.114C10.0327 12.212 10.2381 12.3403 10.4061 12.499C10.5787 12.6577 10.7141 12.8303 10.8121 13.017L10.0911 13.556C10.0211 13.444 9.93474 13.3343 9.83207 13.227C9.73407 13.115 9.61274 13.0217 9.46807 12.947C9.3234 12.8723 9.14607 12.835 8.93607 12.835C8.71674 12.835 8.53707 12.8817 8.39707 12.975C8.26174 13.0637 8.19407 13.2037 8.19407 13.395C8.19407 13.4697 8.21274 13.5467 8.25007 13.626C8.29207 13.7007 8.3854 13.7753 8.53007 13.85C8.6794 13.9247 8.91507 14.0017 9.23707 14.081C9.78307 14.2117 10.1774 14.4077 10.4201 14.669C10.6674 14.9257 10.7911 15.243 10.7911 15.621C10.7911 16.1017 10.6277 16.4703 10.3011 16.727C9.97907 16.979 9.54274 17.105 8.99207 17.105Z"
        fill="white"
      />
      <path
        d="M4.54096 17.119C4.09762 17.119 3.70096 17.014 3.35096 16.804C3.00096 16.594 2.72562 16.2977 2.52496 15.915C2.32896 15.5277 2.23096 15.0727 2.23096 14.55C2.23096 14.0227 2.32896 13.5677 2.52496 13.185C2.72562 12.7977 3.00096 12.499 3.35096 12.289C3.70096 12.0743 4.09762 11.967 4.54096 11.967C4.95629 11.967 5.32962 12.0603 5.66096 12.247C5.99696 12.4337 6.26529 12.695 6.46596 13.031L5.65396 13.5C5.53729 13.2947 5.38329 13.136 5.19196 13.024C5.00529 12.912 4.78829 12.856 4.54096 12.856C4.26562 12.856 4.02529 12.9283 3.81996 13.073C3.61929 13.213 3.46296 13.409 3.35096 13.661C3.23896 13.913 3.18296 14.2093 3.18296 14.55C3.18296 14.886 3.23896 15.18 3.35096 15.432C3.46296 15.684 3.61929 15.8823 3.81996 16.027C4.02529 16.167 4.26562 16.237 4.54096 16.237C4.78829 16.237 5.00529 16.181 5.19196 16.069C5.38329 15.9523 5.53729 15.7937 5.65396 15.593L6.46596 16.062C6.26529 16.3933 5.99696 16.6523 5.66096 16.839C5.32962 17.0257 4.95629 17.119 4.54096 17.119Z"
        fill="white"
      />
    </svg>

    <app-main-button
      label="Add Movano User"
      iconName="add"
      [fullWidth]="true"
      (buttonClick)="createAdminUser()"
    ></app-main-button>
  </div>
</div>

<div class="movanoUsers">
  <div [ngStyle]="{ display: !loadingAdminUsersList ? 'block' : 'none' }" class="movanoTableBox">
    <p-table
      id="userTable"
      #userTable
      class="movano-Table"
      [globalFilterFields]="[
        'firstName',
        'lastName',
        'role',
        'phone',
        'email',
        'status',
        'lastLogin',
        'creationDate',
        ''
      ]"
      [value]="adminUsers"
      [paginator]="true"
      [rows]="rows"
      [first]="pageSelected"
      [scrollable]="true"
      scrollHeight="75vh"
    >
      <ng-template pTemplate="header">
        <tr [ngClass]="'movanoTable_Header'">
          <!-- <th >Logo</th> -->
          <th>
            First Name
            <!-- <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'name' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'name' ? '#05428f' : '#C4D9EE'"
                />
              </svg> -->
          </th>
          <th>
            Last Name
            <!-- <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'contactName' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'contactName' ? '#05428f' : '#C4D9EE'"
                />
              </svg> -->
          </th>
          <th>
            Role
            <!-- <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'contactPhone' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'contactPhone' ? '#05428f' : '#C4D9EE'"
                />
              </svg> -->
          </th>
          <th>
            Phone
            <!-- <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'contactEmail' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'contactEmail' ? '#05428f' : '#C4D9EE'"
                />
              </svg> -->
          </th>
          <th>
            Email
            <!-- <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'website' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'website' ? '#05428f' : '#C4D9EE'"
                />
              </svg> -->
          </th>
          <th>
            Status
            <!-- <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'creationDate' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'creationDate' ? '#05428f' : '#C4D9EE'"
                />
              </svg> -->
          </th>
          <th>
            Last Login
            <!-- <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                [ngStyle]="{
                  transform: sortMode === 'asc' && sortedBy === 'status' ? 'rotate(180deg)' : 'rotate(0deg)'
                }"
              >
                <path
                  d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                  [attr.fill]="sortedBy === 'status' ? '#05428f' : '#C4D9EE'"
                />
              </svg> -->
          </th>
          <th>
            CreationDate
            <!-- <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [ngStyle]="{
                    transform: sortMode === 'asc' && sortedBy === 'status' ? 'rotate(180deg)' : 'rotate(0deg)'
                  }"
                >
                  <path
                    d="M5.25 -2.29485e-07L5.25 9.1275L1.0575 4.935L-2.62268e-07 6L6 12L12 6L10.9425 4.9425L6.75 9.1275L6.75 -2.95052e-07L5.25 -2.29485e-07Z"
                    [attr.fill]="sortedBy === 'status' ? '#05428f' : '#C4D9EE'"
                  />
                </svg> -->
          </th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-adminUsers let-i="rowIndex">
        <tr
          [ngClass]="'movanoTable_Obj'"
          [ngStyle]="{
            'background-color': i % 2 === 0 ? '#f5f5f5' : '#ffffff'
          }"
        >
          <!-- <td
              [ngStyle]="{
                opacity: adminUsers.status.trim().toLowerCase() === 'deleted' ? 0.3 : 1
              }"
            >
              <img
                [src]="adminUsers.logoUrl"
                alt="{{ adminUsers.name }}-Logo"
                height="35"
                width="70"
                style="object-fit: contain"
              />
            </td> -->
          <td [ngStyle]="{ opacity: adminUsers.enabled === false ? 0.5 : 1 }">
            {{ adminUsers.name }}
          </td>
          <td [ngStyle]="{ opacity: adminUsers.enabled === false ? 0.5 : 1 }">
            {{ adminUsers.familyName }}
          </td>
          <td [ngStyle]="{ opacity: adminUsers.enabled === false ? 0.5 : 1 }">
            {{ adminUsers.accountType }}
          </td>
          <td [ngStyle]="{ opacity: adminUsers.enabled === false ? 0.5 : 1 }">
            {{ adminUsers.phone }}
          </td>
          <td [ngStyle]="{ opacity: adminUsers.enabled === false ? 0.5 : 1 }">
            {{ adminUsers.email }}
          </td>
          <td [ngStyle]="{ opacity: adminUsers.enabled === false ? 0.5 : 1 }">
            <div
              *ngIf="adminUsers.enabled !== null && adminUsers.enabled !== undefined"
              class="movanoTable_Obj_Badge"
              [ngClass]="getBadgeColor(adminUsers.enabled)"
              [ngStyle]="{ textTransform: 'lowercase' }"
              [title]="adminUsers.enabled ? 'enabled' : 'disabled'"
            >
              {{ adminUsers.enabled ? "enabled" : "disabled" }}
            </div>
          </td>
          <td [ngStyle]="{ opacity: adminUsers.enabled === false ? 0.5 : 1 }">
            {{ adminUsers.userLastModifiedDate | date : "MM/dd/yy" }}
          </td>
          <td [ngStyle]="{ opacity: adminUsers.enabled === false ? 0.5 : 1 }">
            {{ adminUsers.userCreateDate | date : "MM/dd/yy" }}
          </td>

          <!-- <td
              (click)="handleOrganizationClick(adminUsers)"
              [ngStyle]="{
                opacity: adminUsers.status.trim().toLowerCase() === 'deleted' ? 0.3 : 1
              }"
            >
              <ng-container *ngIf="adminUsers.status.trim().toLowerCase() !== 'deleted'; else deletedStatusFirst">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  [ngStyle]="{ fill: adminUsers.isSelected ? '#054280' : '#bfbfbf' }"
                >
                  <g clip-path="url(#clip0_5058_3143)">
                    <path
                      d="M9 3.375C5.25 3.375 2.0475 5.7075 0.75 9C2.0475 12.2925 5.25 14.625 9 14.625C12.75 14.625 15.9525 12.2925 17.25 9C15.9525 5.7075 12.75 3.375 9 3.375ZM9 12.75C6.93 12.75 5.25 11.07 5.25 9C5.25 6.93 6.93 5.25 9 5.25C11.07 5.25 12.75 6.93 12.75 9C12.75 11.07 11.07 12.75 9 12.75ZM9 6.75C7.755 6.75 6.75 7.755 6.75 9C6.75 10.245 7.755 11.25 9 11.25C10.245 11.25 11.25 10.245 11.25 9C11.25 7.755 10.245 6.75 9 6.75Z"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_5058_3143">
                      <rect width="18" height="18" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </ng-container>

              <ng-template #deletedStatusFirst>
                <span>-</span>
              </ng-template>
            </td> -->

            <ng-container *ngIf="adminUsers.enabled; else deletedStatus">
              <td>
                <img
                  src="../../assets/pencil.svg"
                  width="15"
                  height="15"
                  alt="edit"
                  [ngStyle]="{ fill: adminUsers.isEdit ? '#054280' : '#bfbfbf' }"
                  (click)="editAdminUser(adminUsers)"
                />
              </td>
            </ng-container>

            <ng-template #deletedStatus>
              <td  [ngStyle]="{ position: 'relative', left: '-0.3%' }">
                <img
                  src="../../assets/replay.svg"
                  width="27"
                  height="27"
                  alt="recover"
                  (click)="recoverAdminUser(adminUsers)"
                />
              </td>
            </ng-template>
        </tr>
      </ng-template>

      <ng-template pTemplate="paginatorright" let-state>
        <div class="movanoPaginator">
          <svg (click)="previousPage()" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.3333 5.33335L3.21996 5.33335L6.94663 1.60669L5.99996 0.666687L0.666626 6.00002L5.99996 11.3334L6.93996 10.3934L3.21996 6.66669L11.3333 6.66669V5.33335Z"
              [ngStyle]="{ fill: state.page > 0 ? '#0B84FF' : '#AABED3' }"
            />
          </svg>

          <button *ngIf="!isFirstPageInRange()" (click)="selectPage(1)" [ngClass]="{ 'active-page': actualPage === 1 }">
            1
          </button>

          <svg *ngIf="shouldShowLeftEllipsis()" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="18" height="8" rx="4" fill="#C4D9EE" />
            <circle cx="9" cy="4" r="1" fill="var(--main-blue-dark)" />
            <circle cx="13" cy="4" r="1" fill="var(--main-blue-dark)" />
            <circle cx="5" cy="4" r="1" fill="var(--main-blue-dark)" />
          </svg>

          <button
            *ngFor="let page of getDisplayedPages()"
            [ngClass]="{ 'active-page': page === actualPage }"
            (click)="selectPage(page)"
          >
            {{ page }}
          </button>

          <svg *ngIf="shouldShowRightEllipsis()" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="18" height="8" rx="4" fill="#C4D9EE" />
            <circle cx="9" cy="4" r="1" fill="var(--main-blue-dark)" />
            <circle cx="13" cy="4" r="1" fill="var(--main-blue-dark)" />
            <circle cx="5" cy="4" r="1" fill="var(--main-blue-dark)" />
          </svg>

          <button
            *ngIf="!isLastPageInRange()"
            (click)="selectPage(totalPages)"
            [ngClass]="{ 'active-page': actualPage === totalPages }"
          >
            {{ totalPages }}
          </button>

          <svg (click)="nextPage()" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.666647 6.66665L8.77998 6.66665L5.05331 10.3933L5.99998 11.3333L11.3333 5.99998L5.99998 0.666646L5.05998 1.60665L8.77998 5.33331L0.666647 5.33331L0.666647 6.66665Z"
              [ngStyle]="{ fill: state.page < state.pageCount - 1 ? '#0B84FF' : '#AABED3' }"
            />
          </svg>
        </div>
      </ng-template>
    </p-table>
    <div id="mobileScroll" class="movanoTableBox_mobileShadow"></div>
    <div id="mobileScroll_Left" class="movanoTableBox_mobileShadow movanoTableBox_mobileShadow_Left"></div>
  </div>

  <div *ngIf="loadingAdminUsersList" style="position: absolute; top: 50%; left: 50%">
    <p-progressSpinner
      styleClass="{{ darkMode ? 'custom-spinner' : 'custom-spinner-blue' }}"
      strokeWidth="2"
      animationDuration="1.5s"
    >
    </p-progressSpinner>
  </div>
</div>
